import { Stack } from '@mui/material'
import { FC, ReactNode } from 'react'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import { OutputButtonRow } from 'src/features/reportExport/list/components/OutputButtonRow'

type Props = {
  children: ReactNode
}

/**
 * レポート出力一覧画面において、データの取得状態に関わらず必ず表示する部分を抜き出したコンポーネント
 */
export const ReportExportListWrapper: FC<Props> = ({ children }) => {
  return (
    <Stack>
      <Header>
        <HeaderTitle title="レポート出力" />
      </Header>
      <OutputButtonRow />
      {children}
    </Stack>
  )
}
